import React from 'react';
import CustomModal from '../../../assets/components/ModalComonent';
import classes from '../styles/style.module.css'

const AwardsDialog = ({ open, onClose }) => {
    const AwardsContent =
        <div>
            <img src='/images/hubble/dialogs/awards.png' className='w-75' alt='awards' />
            <h4 className={classes.dialogHeading}>توضیحات</h4>
            <p style={{textAlign:'justify'}}>
                ⚠️ جهت شرکت در جشنواره هابل ثبت نام لازم نمی باشد.
                عضویت در راه بهشت برای شرکت در هابل کافی می باشد.
                پس از تهیه اثر خود به صورت ویدیویی آن را در زمان تعیین شده مرحله مربوط ارسال کنید تا در آن مرحله شرکت کنید.
                <br />
                <br />
                🔆 رشته های جشنواره استعدادیابی هابل
                <br />
                🔮 ۱۰ تا رشته اصلی عبارتند از:
                <br />
                ۱. استندآپ کمدی و نمایش
                <br />
                ۲. تقلید صدا و دوبله
                <br />
                ۳. مجری گری<br />
                ۴. خوانندگی و هنرهای مرتبط با عرصه موسیقی<br />
                ۵. شعرخوانی/ نقالی/ روایتگری/ خطابه خوانی<br />
                ۶. سرود / تواشیح /ابتهال خوانی<br />
                ۷. خلاقیت‌های علمی شامل آزمایشات فیزیک و شیمی، تکنیک‌های خطای دید، محاسبات ذهنی ریاضی، روش تدریس نوآورانه و...<br />
                ۸. خلاقیت‌های هنری و تجسمی شامل ایده های خلاق در عرصه های نقاشی، خطاطی، مجسمه سازی و کلیه هنرهای تجسمی<br />
                ۹. خلاقیت‌های سرگرمی، حرکتی و ورزشی شامل اجرای حرکات نمایشی با توپ، نمایش‌های رزمی، ورزش‌های پهلوانی، تیراندازی، سایه بازی، آکروبات، شعبده و...<br />
                ۱۰. مهارت و خلاقیت های صنعتی: اگر مهارت یا خلاقیت ویژه ای دارید که درصنعت فولاد می تواند گره گشا باشدیا یکی از نیازها و امورات فنی و صنعتی شرکت را با مهارت خاص و ویژه ای انجام می دهید یا در انجام برخی امورات شرکت خلاقانه عمل میکنید یا مانند اینها... می توانید در این بخش جشنواره شرکت نمایید.
            </p>
        </div>


    return (
        <div>
            <CustomModal
                yellow
                open={open}
                closeHandler={onClose}
                inputDialog={true}
                dialogContent={AwardsContent}
            />
        </div>
    )
}

export default AwardsDialog